import {apiURL, StandardHeadersMode} from '@logistics-frontend/client-core/api/corp'
import {createYaAuthMiddleware, fetchWithHeaders, withCSRF} from '@logistics-frontend/core/utils/network'
import * as t from '@logistics-frontend/modules/tariffs-v2/types'
import {get, log, logGroupEnd, logGroupStart, pipe, raise, tap} from '@logistics-frontend/utils'
import {addQuery} from '@logistics-frontend/utils/url'

import {config} from './config'

const SERVICE = 'cargo'

const b2bFetch = pipe(
  fetchWithHeaders,
  createYaAuthMiddleware({
    host: config.config.b2bApiHost || raise('[tariffs] b2b-api-lk.go host not found'),
    headers: {},
  }),
  withCSRF,
)

const toTariffList = get('body.categories')
const toZoneList = get('body.zones')

function b2bApiUrl(url: string): string {
  return apiURL(url, {
    version: '1.0',
    type: 'corp-cabinet',
  })
}

export function fetchTariffList(params: t.TariffListRequestArgs): Promise<t.Category[]> {
  return Promise.resolve(params)
    .then(tap(logGroupStart('fetchTariffList', true)))
    .then(tap(log('params  ')))
    .then(({zone, country}) => {
      return b2bFetch({
        meta: {
          standardHeadersMode: StandardHeadersMode.Disable,
        },
        options: {
          credentials: 'include',
        },
        url: addQuery(b2bApiUrl('public-tariff'), {
          product: 'default',
          zone_name: zone,
          country,
          service: SERVICE,
        }),
      })
    })
    .then(tap(log('response')))
    .then(toTariffList)
    .then(tap(log('model   ')))
    .then(tap(logGroupEnd()))
}

export function fetchTariffZones(): Promise<t.TariffZonesItem[]> {
  return b2bFetch({
    url: addQuery(b2bApiUrl('public/tariff_zones'), {service: SERVICE}),
  })
    .then(tap(logGroupStart('fetchTariffZones', true)))
    .then(tap(log('response')))
    .then(toZoneList)
    .then(tap(log('model   ')))
    .then(tap(logGroupEnd()))
}
